var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarNav9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Nav-tabs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 26.3332C14.558 26.3332 14.1341 26.1576 13.8215 25.845C13.509 25.5325 13.3334 25.1085 13.3334 24.6665V11.3332C13.3334 10.8911 13.509 10.4672 13.8215 10.1547C14.1341 9.8421 14.558 9.66651 15 9.66651H21.6667C21.9305 9.66608 22.1918 9.71784 22.4355 9.81881C22.6792 9.91979 22.9005 10.068 23.0867 10.2548L26.0767 13.2448C26.2641 13.4311 26.4127 13.6526 26.514 13.8966C26.6152 14.1407 26.6671 14.4023 26.6667 14.6665V24.6665C26.6667 25.1085 26.4911 25.5325 26.1786 25.845C25.866 26.1576 25.4421 26.3332 25 26.3332H15Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.6666 9.6665V13.8332C21.6666 14.0542 21.7544 14.2661 21.9107 14.4224C22.067 14.5787 22.2789 14.6665 22.5 14.6665H26.6666",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.5833 22.1667C20.7339 22.1667 21.6667 21.2339 21.6667 20.0833C21.6667 18.9327 20.7339 18 19.5833 18C18.4327 18 17.5 18.9327 17.5 20.0833C17.5 21.2339 18.4327 22.1667 19.5833 22.1667Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.0834 21.5835L22.5 23.0002",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarNav9);
export default __webpack_public_path__ + "static/media/sidebar-nav-9.b7e9d3e0979a03c88d94c82690c6ba82.svg";
export { ForwardRef as ReactComponent };